import React, { useCallback, useRef } from 'react';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "../ProductCardComponent/Index.jsx";
import './productcarouselComponent.css';

const NextArrow = (props) => {
  const { className, onClick, disabled } = props;
  return (
    <div 
      className={`${className} custom-arrow product-right ${disabled ? 'disabled-arrow' : ''}`} 
      onClick={disabled ? null : onClick}
    >
      <i
        className="fas fa-chevron-right"
        style={{ 
          fontSize: 24, 
          color: disabled ? "#ccc" : "black",
          opacity: disabled ? 0.5 : 1 
        }}
      ></i>
    </div>
  );
};

const PrevArrow = (props) => {
  const { className, onClick, disabled } = props;
  return (
    <div 
      className={`${className} custom-arrow product-left ${disabled ? 'disabled-arrow' : ''}`} 
      onClick={disabled ? null : onClick}
    >
      <i
        className="fas fa-chevron-left"
        style={{ 
          fontSize: 24, 
          color: disabled ? "#ccc" : "black",
          opacity: disabled ? 0.5 : 1 
        }}
      ></i>
    </div>
  );
};

const HorizontalCarousel = ({ products, onMainImageClick }) => {
  const sliderRef = useRef(null);
  const isAnimatingRef = useRef(false);
  const timeoutRef = useRef(null);
  
  const handleBeforeChange = useCallback(() => {
    isAnimatingRef.current = true;
  }, []);

  const handleAfterChange = useCallback(() => {
    isAnimatingRef.current = false;
  }, []);

  const handleArrowClick = useCallback((direction) => {
    if (isAnimatingRef.current) {
      return; // Prevent clicks during animation
    }

    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }

    isAnimatingRef.current = true;
    
    if (direction === 'next') {
      sliderRef.current?.slickNext();
    } else {
      sliderRef.current?.slickPrev();
    }

    timeoutRef.current = setTimeout(() => {
      isAnimatingRef.current = false;
    }, 500); // Match with transition duration
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <NextArrow onClick={() => handleArrowClick('next')} disabled={isAnimatingRef.current} />,
    prevArrow: <PrevArrow onClick={() => handleArrowClick('prev')} disabled={isAnimatingRef.current} />,
    autoplay: true,
    autoplaySpeed: 2000,
    pauseOnHover: true,
    beforeChange: handleBeforeChange,
    afterChange: handleAfterChange,
    className: 'product-slider',
    responsive: [
      {
        // iPad Pro 12.9" (2732x2048) - Landscape & Portrait
        breakpoint: 1366,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      },
      {
        // iPad Pro 11" (2388x1668) & iPad Air (2360x1640) - Landscape & Portrait
        breakpoint: 1194,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      },
      {
        // iPad Mini 6 (2266x1488) - Landscape & Portrait
        breakpoint: 1133,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      },
      {
        // iPad Mini 5 and older (2048x1536) - Landscape
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      },
      {
        // iPad Mini/Air/Pro Portrait
        breakpoint: 820,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      },
      {
        // Mobile devices
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          autoplay: true,
          autoplaySpeed: 2000,
        }
      }
    ]
  };

  return (
    <div className="carousel-wrapper">
      <div 
        className="product-slider-container"
        style={{ 
          opacity: isAnimatingRef.current ? 0.7 : 1,
          transition: 'opacity 0.3s ease-in-out' 
        }}
      >
        <Slider ref={sliderRef} {...settings}>
          {products.map((product) => (
            <ProductCard
              key={product.ProductId}
              product={product}
              onMainImageClick={onMainImageClick}
            />
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default HorizontalCarousel;